import DiamondIntro from './DiamondIntro';
import DiamondGrab from './DiamondGrab';
import Diamond from './Diamond';
import DiamondOutro from './DiamondOutro';

export default [DiamondIntro, DiamondGrab, Diamond, DiamondOutro];
